import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
  color: #18181b;
}

* {
  box-sizing: border-box;
}

button,
input {
  font: inherit;
}

.auth-shell {
  --ink: #111113;
  --ink-soft: #29292d;
  --muted: #71717a;
  --line: #e4e4e7;
  --surface: #fafafa;
  --accent: #6d5dfc;
  --accent-dark: #5546e8;
  --danger: #c9364b;
  min-height: 100vh;
  min-height: 100svh;
  display: grid;
  grid-template-columns: minmax(540px, 1.16fr) minmax(480px, 0.84fr);
  background: #f7f7f8;
  font-family: Pretendard, "Noto Sans KR", Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.visual-panel {
  position: relative;
  isolation: isolate;
  display: flex;
  min-height: 100vh;
  min-height: 100svh;
  overflow: hidden;
  flex-direction: column;
  padding: clamp(32px, 4.5vw, 68px);
  color: #ffffff;
  background: #0b0b0d;
}

.visual-panel::before {
  position: absolute;
  z-index: -1;
  top: -24%;
  left: 32%;
  width: 74%;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(109, 93, 252, 0.17), rgba(109, 93, 252, 0) 68%);
  content: "";
  pointer-events: none;
}

.visual-grid {
  position: absolute;
  z-index: -2;
  inset: 0;
  opacity: 0.34;
  background-image: linear-gradient(rgba(255, 255, 255, 0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.035) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: linear-gradient(to bottom, black, transparent 82%);
  pointer-events: none;
}

.brand-lockup,
.mobile-brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: inherit;
  text-decoration: none;
}

.brand-mark,
.mobile-brand-mark {
  display: grid;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  place-items: center;
  border-radius: 12px;
}

.brand-mark {
  color: #0b0b0d;
  background: #ffffff;
}

.brand-mark svg,
.mobile-brand-mark svg {
  width: 27px;
  height: 27px;
}

.brand-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.brand-copy strong,
.mobile-brand strong {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.brand-copy span,
.mobile-brand small {
  color: #85858d;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.visual-copy {
  width: min(100%, 650px);
  margin: clamp(48px, 7vh, 88px) 0 30px;
}

.section-kicker,
.form-kicker {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.section-kicker {
  color: #a6a6ae;
}

.live-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #b6ff58;
  box-shadow: 0 0 0 4px rgba(182, 255, 88, 0.1);
}

.visual-copy h1 {
  margin: 17px 0 16px;
  font-size: clamp(38px, 4.3vw, 62px);
  font-weight: 760;
  line-height: 1.13;
  letter-spacing: -0.055em;
  word-break: keep-all;
}

.visual-copy h1 span {
  color: #a8a8b0;
}

.visual-copy p {
  max-width: 590px;
  margin: 0;
  color: #96969f;
  font-size: 14px;
  line-height: 1.75;
  word-break: keep-all;
}

.studio-window {
  width: min(100%, 680px);
  overflow: hidden;
  margin-top: auto;
  border: 1px solid #303035;
  border-radius: 18px;
  background: #151518;
  box-shadow: 0 28px 90px rgba(0, 0, 0, 0.48);
}

.studio-toolbar {
  display: grid;
  height: 42px;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 14px;
  color: #777780;
  border-bottom: 1px solid #29292e;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.window-controls {
  display: flex;
  gap: 6px;
}

.window-controls span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #46464d;
}

.render-state {
  display: inline-flex;
  align-items: center;
  justify-self: end;
  gap: 6px;
  color: #b6ff58;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.render-state i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
  animation: pulse 1.8s ease-in-out infinite;
}

.preview-frame {
  position: relative;
  min-height: 210px;
  overflow: hidden;
  background: radial-gradient(circle at 75% 25%, rgba(41, 211, 255, 0.16), transparent 28%), radial-gradient(circle at 30% 70%, rgba(255, 58, 163, 0.16), transparent 31%), linear-gradient(145deg, #202026, #0c0c0e 66%);
}

.preview-noise {
  position: absolute;
  inset: 0;
  opacity: 0.16;
  background-image: repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(255, 255, 255, 0.035) 4px);
}

.paper-plane {
  position: absolute;
  top: 24px;
  left: 8%;
  width: 37%;
  height: 154px;
  padding: 29px 25px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  background: rgba(232, 232, 235, 0.1);
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.3);
  transform: rotate(-4deg);
}

.paper-plane strong {
  display: block;
  margin-bottom: 17px;
  color: #8a8a94;
  font-size: 7px;
  letter-spacing: 0.2em;
}

.paper-line {
  display: block;
  width: 68%;
  height: 4px;
  margin-bottom: 9px;
  border-radius: 2px;
  background: #6f6f78;
}

.paper-line-wide {
  width: 100%;
}

.paper-line-short {
  width: 43%;
}

.spectrum {
  position: absolute;
  border-radius: 50%;
  filter: blur(2px);
  mix-blend-mode: screen;
}

.spectrum-one {
  top: 27px;
  right: 14%;
  width: 140px;
  height: 140px;
  background: conic-gradient(from 210deg, #ff3da4, #785dff, #35dcff, #f6ff77, #ff3da4);
  opacity: 0.76;
  animation: drift 8s ease-in-out infinite alternate;
}

.spectrum-two {
  right: 7%;
  bottom: -56px;
  width: 122px;
  height: 122px;
  background: radial-gradient(circle at 35% 35%, #ffb84d, #ff3d81 46%, rgba(109, 93, 252, 0) 72%);
  opacity: 0.72;
}

.play-mark {
  position: absolute;
  top: 50%;
  left: 58%;
  display: grid;
  width: 48px;
  height: 48px;
  place-items: center;
  color: #17171a;
  border: 1px solid rgba(255, 255, 255, 0.68);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.24);
  transform: translate(-50%, -50%);
  backdrop-filter: blur(8px);
}

.play-mark svg {
  width: 22px;
  height: 22px;
}

.preview-caption {
  position: absolute;
  right: 18px;
  bottom: 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}

.preview-caption small {
  color: #9b9ba4;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.preview-caption strong {
  color: #f4f4f5;
  font-size: 10px;
  font-weight: 700;
}

.frame-time {
  position: absolute;
  right: 12px;
  top: 12px;
  padding: 4px 6px;
  color: #d4d4d8;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.5);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 8px;
}

.editor-track {
  position: relative;
  display: grid;
  height: 48px;
  grid-template-columns: 82px 1fr;
  align-items: center;
  overflow: hidden;
  border-top: 1px solid #29292e;
  border-bottom: 1px solid #29292e;
  background: #111114;
}

.track-label {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  padding-left: 14px;
  color: #92929b;
  border-right: 1px solid #29292e;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.track-label span:last-child {
  color: #57575e;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  letter-spacing: 0;
}

.waveform {
  display: flex;
  height: 30px;
  align-items: center;
  gap: clamp(3px, 0.5vw, 7px);
  padding: 0 14px;
}

.waveform i {
  width: 2px;
  height: 8px;
  border-radius: 2px;
  background: #7568f8;
}

.waveform i:nth-child(3n) {
  height: 24px;
}

.waveform i:nth-child(4n) {
  height: 16px;
}

.waveform i:nth-child(5n) {
  height: 28px;
}

.waveform i:nth-child(7n) {
  background: #ff4fa3;
}

.playhead {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 57%;
  width: 1px;
  background: #ffffff;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.playhead::before {
  position: absolute;
  top: 0;
  left: -3px;
  width: 7px;
  height: 5px;
  background: #ffffff;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  content: "";
}

.scene-strip {
  display: grid;
  height: 27px;
  grid-template-columns: 1.1fr 0.8fr 1.3fr 0.7fr;
  gap: 2px;
  padding: 5px 7px;
  background: #101012;
}

.scene-block {
  border-radius: 3px;
  background: #303036;
}

.scene-block-one {
  border-left: 3px solid #27d3ff;
}

.scene-block-two {
  border-left: 3px solid #7965ff;
}

.scene-block-three {
  border-left: 3px solid #ff4fa3;
}

.scene-block-four {
  border-left: 3px solid #ffb84d;
}

.visual-footer {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-top: 25px;
  color: #696970;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.visual-footer i {
  width: 22px;
  height: 1px;
  background: #36363b;
}

.form-panel {
  display: flex;
  min-height: 100vh;
  min-height: 100svh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 34px clamp(34px, 5vw, 76px) 24px;
  background: radial-gradient(circle at 100% 0, rgba(109, 93, 252, 0.055), transparent 30%), #f7f7f8;
}

.mobile-brand {
  display: none;
  align-self: flex-start;
  color: var(--ink);
}

.mobile-brand-mark {
  color: #ffffff;
  background: var(--ink);
}

.mobile-brand > span:last-child {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.auth-card {
  width: min(100%, 430px);
  margin: auto 0;
  padding: 38px 40px;
  border: 1px solid #e4e4e7;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 20px 55px rgba(24, 24, 27, 0.07);
  backdrop-filter: blur(14px);
}

.form-kicker {
  color: #777780;
}

.card-heading {
  margin-bottom: 28px;
}

.card-heading.compact {
  margin-top: 22px;
  margin-bottom: 24px;
}

.card-heading h2 {
  margin: 10px 0 8px;
  color: var(--ink);
  font-size: 28px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.045em;
}

.card-heading p {
  margin: 0;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.6;
  word-break: keep-all;
}

.auth-form {
  display: grid;
  gap: 17px;
}

.register-form {
  gap: 14px;
}

.field-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.field-group {
  min-width: 0;
}

.field-group label,
.label-row {
  color: #343439;
  font-size: 11px;
  font-weight: 750;
}

.field-group > label {
  display: inline-block;
  margin-bottom: 7px;
}

.label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
}

.label-row label {
  font: inherit;
}

.input-wrap {
  position: relative;
  display: flex;
  min-height: 49px;
  align-items: center;
  overflow: hidden;
  border: 1px solid #d4d4d8;
  border-radius: 10px;
  background: #ffffff;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;
}

.input-wrap:hover {
  border-color: #b7b7bd;
}

.input-wrap:focus-within {
  border-color: var(--ink);
  box-shadow: 0 0 0 3px rgba(24, 24, 27, 0.09);
}

.input-wrap.has-error {
  border-color: var(--danger);
  background: #fffafb;
}

.input-wrap input {
  width: 100%;
  min-width: 0;
  height: 47px;
  padding: 0 14px;
  color: var(--ink);
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 12px;
}

.input-wrap .input-icon + input {
  padding-left: 2px;
}

.input-wrap input::placeholder {
  color: #a1a1aa;
}

.input-icon {
  display: grid;
  width: 41px;
  flex: 0 0 41px;
  place-items: center;
  color: #8c8c95;
}

.input-icon svg {
  width: 18px;
  height: 18px;
}

.visibility-button {
  display: grid;
  width: 43px;
  height: 43px;
  flex: 0 0 43px;
  place-items: center;
  margin-right: 2px;
  padding: 0;
  color: #777780;
  border: 0;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}

.visibility-button:hover {
  color: var(--ink);
  background: #f4f4f5;
}

.visibility-button svg {
  width: 19px;
  height: 19px;
}

.field-error {
  margin: 6px 2px 0;
  color: var(--danger);
  font-size: 10px;
  font-weight: 650;
}

.form-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.check-label,
.agreement-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #62626b;
  cursor: pointer;
  font-size: 10px;
  line-height: 1.5;
}

.check-label input,
.agreement-item input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.custom-check {
  display: grid;
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  place-items: center;
  color: transparent;
  border: 1px solid #b8b8bf;
  border-radius: 5px;
  background: #ffffff;
  transition: 0.16s ease;
}

.custom-check svg {
  width: 13px;
  height: 13px;
}

.check-label input:checked + .custom-check,
.agreement-item input:checked + .custom-check {
  color: #ffffff;
  border-color: var(--ink);
  background: var(--ink);
}

.check-label input:focus-visible + .custom-check,
.agreement-item input:focus-visible + .custom-check {
  outline: 3px solid rgba(109, 93, 252, 0.2);
  outline-offset: 2px;
}

.text-button,
.password-toggle-row {
  padding: 0;
  color: #4f46d7;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 10px;
  font-weight: 750;
}

.text-button:hover,
.password-toggle-row:hover {
  color: #3128b7;
  text-decoration: underline;
}

.text-button.strong {
  font-size: 11px;
}

.primary-button {
  display: inline-flex;
  width: 100%;
  min-height: 50px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 18px;
  color: #ffffff;
  border: 1px solid #08080a;
  border-radius: 10px;
  background: #111113;
  box-shadow: 0 10px 20px rgba(17, 17, 19, 0.13);
  cursor: pointer;
  font-size: 12px;
  font-weight: 800;
  transition: transform 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;
}

.primary-button:hover:not(:disabled) {
  background: #29292d;
  box-shadow: 0 13px 25px rgba(17, 17, 19, 0.18);
  transform: translateY(-1px);
}

.primary-button:disabled {
  cursor: wait;
  opacity: 0.62;
}

.account-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin: 20px 0;
  color: #777780;
  font-size: 10px;
}

.sample-access {
  display: grid;
  width: 100%;
  min-height: 54px;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 9px 11px;
  color: #3f3f46;
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  background: #fafafa;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.16s ease, background 0.16s ease;
}

.sample-access:hover {
  border-color: #c8c8ce;
  background: #f4f4f5;
}

.sample-icon {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  color: #ffffff;
  border-radius: 8px;
  background: linear-gradient(145deg, #6d5dfc, #e83e92);
}

.sample-icon svg {
  width: 15px;
  height: 15px;
}

.sample-access > span:nth-child(2) {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.sample-access strong {
  font-size: 10px;
  font-weight: 800;
}

.sample-access small {
  color: #8a8a93;
  font-size: 8px;
}

.sample-access em {
  color: #686870;
  font-size: 8px;
  font-style: normal;
  font-weight: 750;
  white-space: nowrap;
}

.security-note {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin: 14px 2px 0;
  color: #92929b;
  font-size: 8px;
  line-height: 1.55;
  word-break: keep-all;
}

.security-note svg {
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  margin-top: 1px;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 0;
  color: #71717a;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 10px;
  font-weight: 700;
}

.back-button:hover {
  color: var(--ink);
}

.back-button svg {
  width: 16px;
  height: 16px;
}

.password-toggle-row {
  justify-self: end;
  margin-top: -5px;
}

.agreement-list {
  display: grid;
  gap: 9px;
  padding: 13px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: #fafafa;
}

.agreement-item {
  align-items: flex-start;
}

.agreement-item .custom-check {
  margin-top: 1px;
}

.agreement-item span:last-child {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px;
}

.agreement-item b {
  color: #4f46d7;
  font-size: 9px;
}

.agreement-item b.optional {
  color: #777780;
}

.agreement-item small {
  display: block;
  width: 100%;
  margin-top: 2px;
  color: #92929b;
  font-size: 8px;
}

.message-box {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 11px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 650;
  line-height: 1.5;
}

.message-box svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}

.error-message {
  color: #a32f40;
  border: 1px solid #efc2c8;
  background: #fff5f6;
}

.success-message {
  color: #11704e;
  border: 1px solid #b9e2d1;
  background: #f0fbf6;
}

.tab-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3px;
  margin-bottom: 22px;
  padding: 3px;
  border-radius: 10px;
  background: #ececee;
}

.tab-list button {
  min-height: 39px;
  color: #777780;
  border: 0;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font-size: 11px;
  font-weight: 750;
}

.tab-list button.active {
  color: var(--ink);
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(24, 24, 27, 0.09);
}

.spinner {
  width: 17px;
  height: 17px;
  animation: spin 0.8s linear infinite;
}

.sample-access:focus-visible,
.primary-button:focus-visible,
.back-button:focus-visible,
.text-button:focus-visible,
.visibility-button:focus-visible,
.password-toggle-row:focus-visible,
.tab-list button:focus-visible,
.legal-footer a:focus-visible {
  outline: 3px solid rgba(109, 93, 252, 0.22);
  outline-offset: 3px;
}

.legal-footer {
  display: flex;
  width: min(100%, 430px);
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: auto;
  padding-top: 24px;
  color: #a1a1aa;
  font-size: 8px;
}

.legal-footer nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
}

.legal-footer a {
  color: #777780;
  text-decoration: none;
}

.legal-footer a:hover {
  color: var(--ink);
  text-decoration: underline;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.35;
  }
}
@keyframes drift {
  to {
    transform: translate(-12px, 8px) rotate(12deg);
  }
}
@media (max-width: 1120px) {
  .auth-shell {
    grid-template-columns: minmax(470px, 1fr) minmax(440px, 0.9fr);
  }
  .visual-panel {
    padding: 38px;
  }
  .visual-copy h1 {
    font-size: 44px;
  }
}
@media (max-height: 820px) and (min-width: 861px) {
  .visual-panel {
    padding-top: 30px;
    padding-bottom: 26px;
  }
  .visual-copy {
    margin: 34px 0 22px;
  }
  .visual-copy h1 {
    font-size: 40px;
  }
  .preview-frame {
    min-height: 170px;
  }
  .paper-plane {
    top: 18px;
    height: 128px;
  }
  .form-panel {
    justify-content: flex-start;
    overflow-y: auto;
    padding-top: 24px;
  }
}
@media (max-width: 860px) {
  .auth-shell {
    display: block;
  }
  .visual-panel {
    display: none;
  }
  .form-panel {
    min-height: 100vh;
    min-height: 100svh;
    justify-content: flex-start;
    padding: 28px 24px 20px;
    background: radial-gradient(circle at 100% 0, rgba(109, 93, 252, 0.1), transparent 28%), #f7f7f8;
  }
  .mobile-brand {
    display: inline-flex;
  }
  .auth-card {
    margin: auto 0;
  }
  .legal-footer {
    padding-top: 28px;
  }
}
@media (max-width: 520px) {
  .form-panel {
    padding: 20px 16px 16px;
  }
  .mobile-brand-mark {
    width: 39px;
    height: 39px;
    flex-basis: 39px;
  }
  .auth-card {
    margin-top: 28px;
    padding: 28px 22px;
    border-radius: 16px;
  }
  .card-heading h2 {
    font-size: 25px;
  }
  .field-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .sample-access {
    grid-template-columns: auto 1fr;
  }
  .sample-access em {
    display: none;
  }
  .legal-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 9px;
  }
  .legal-footer nav {
    justify-content: flex-start;
    gap: 11px;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    public view: string = 'login';
    public recoverMode: string = 'id';
    public passwordVisible: boolean = false;
    public registerPasswordVisible: boolean = false;
    public loginLoading: boolean = false;
    public registerLoading: boolean = false;
    public errorMessage: string = '';
    public registerError: string = '';
    public recoveryError: string = '';
    public recoverySent: boolean = false;
    public fieldErrors: any = {};

    public data: any = {
        identifier: '',
        password: '',
        remember: false
    };

    public registerData: any = {
        identifier: '',
        email: '',
        password: '',
        passwordConfirm: '',
        nickname: '',
        terms: false,
        privacy: false,
        improvement: false
    };

    public recoveryData: any = {
        identifier: '',
        email: ''
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();

        const authenticated = await this.service.auth.check();
        if (authenticated) {
            this.moveToAuthenticatedPage(this.service.auth.session?.role || '');
            return;
        }

        try {
            const rememberedId = localStorage.getItem('paperflow.rememberedId');
            if (rememberedId) {
                this.data.identifier = rememberedId;
                this.data.remember = true;
            }
        } catch (e) {
            // 저장소 사용이 제한된 브라우저에서도 로그인은 계속 동작합니다.
        }

        await this.service.render();
    }

    private moveToAuthenticatedPage(role: string) {
        location.href = '/dashboard';
    }

    public async go(view: string) {
        this.view = view;
        this.errorMessage = '';
        this.registerError = '';
        this.recoveryError = '';
        this.recoverySent = false;
        this.fieldErrors = {};
        await this.service.render();
    }

    public async fillDemoAccount() {
        this.data.identifier = 'admin';
        this.data.password = '1234';
        this.data.remember = false;
        this.errorMessage = '';
        this.fieldErrors = {};
        await this.service.render();
    }

    public async togglePassword() {
        this.passwordVisible = !this.passwordVisible;
        await this.service.render();
    }

    public async toggleRegisterPassword() {
        this.registerPasswordVisible = !this.registerPasswordVisible;
        await this.service.render();
    }

    public async login() {
        this.errorMessage = '';
        this.fieldErrors = {};

        const identifier = String(this.data.identifier || '').trim();
        const password = String(this.data.password || '');

        if (!identifier) {
            this.fieldErrors.identifier = '아이디를 입력해주세요.';
        }
        if (!password) {
            this.fieldErrors.password = '비밀번호를 입력해주세요.';
        }
        if (Object.keys(this.fieldErrors).length > 0) {
            await this.service.render();
            return;
        }

        this.loginLoading = true;
        await this.service.render();

        const { code, data } = await wiz.call('login', {
            identifier: identifier,
            password: password,
            remember: this.data.remember
        });

        if (code === 200 && data?.authenticated === true) {
            try {
                if (this.data.remember) {
                    localStorage.setItem('paperflow.rememberedId', identifier);
                } else {
                    localStorage.removeItem('paperflow.rememberedId');
                }
            } catch (e) {
                // 로그인 상태 유지용 아이디 저장 실패는 인증을 막지 않습니다.
            }

            this.moveToAuthenticatedPage(data?.role || '');
            return;
        }

        this.loginLoading = false;
        this.errorMessage = data?.message || '로그인에 실패했습니다. 입력 정보를 확인해주세요.';
        await this.service.render();
    }

    public async register() {
        this.registerError = '';

        const identifier = String(this.registerData.identifier || '').trim();
        const nickname = String(this.registerData.nickname || '').trim();
        const email = String(this.registerData.email || '').trim();
        const password = String(this.registerData.password || '');

        if (!/^[a-zA-Z0-9]{4,32}$/.test(identifier)) {
            this.registerError = '아이디는 영문 또는 숫자 4~32자로 입력해주세요.';
        } else if (!nickname) {
            this.registerError = '닉네임을 입력해주세요.';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            this.registerError = '올바른 이메일 주소를 입력해주세요.';
        } else if (password.length < 8) {
            this.registerError = '비밀번호는 8자 이상으로 입력해주세요.';
        } else if (password !== this.registerData.passwordConfirm) {
            this.registerError = '비밀번호가 서로 일치하지 않습니다.';
        } else if (!this.registerData.terms || !this.registerData.privacy) {
            this.registerError = '이용약관과 개인정보 수집 동의는 필수입니다.';
        }

        if (this.registerError) {
            await this.service.render();
            return;
        }

        this.registerLoading = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('login', {
                action: 'register',
                identifier: identifier,
                nickname: nickname,
                email: email,
                password: password,
                terms: this.registerData.terms,
                privacy: this.registerData.privacy,
                improvement: this.registerData.improvement
            });

            if (code !== 201 || data?.created !== true) {
                this.registerError = data?.message || '회원가입에 실패했습니다. 입력 정보를 확인해주세요.';
                return;
            }

            await this.service.modal.show({
                title: '회원가입 완료',
                message: '계정이 생성되었습니다. 가입한 아이디와 비밀번호로 로그인해주세요.',
                cancel: false,
                action: '로그인하기',
                actionBtn: 'success',
                status: 'success'
            });

            this.data.identifier = String(data?.identifier || identifier);
            this.data.password = '';
            this.registerData = {
                identifier: '',
                email: '',
                password: '',
                passwordConfirm: '',
                nickname: '',
                terms: false,
                privacy: false,
                improvement: false
            };
            await this.go('login');
        } catch (e) {
            this.registerError = '회원가입 요청을 처리하지 못했습니다. 잠시 후 다시 시도해주세요.';
        } finally {
            this.registerLoading = false;
            await this.service.render();
        }
    }

    public async openRecovery(mode: string) {
        this.recoverMode = mode;
        this.recoveryData.identifier = mode === 'password' ? String(this.data.identifier || '').trim() : '';
        this.recoveryData.email = '';
        await this.go('recover');
    }

    public async setRecoveryMode(mode: string) {
        this.recoverMode = mode;
        this.recoveryError = '';
        this.recoverySent = false;
        await this.service.render();
    }

    public async submitRecovery() {
        this.recoveryError = '';
        this.recoverySent = false;

        const identifier = String(this.recoveryData.identifier || '').trim();
        const email = String(this.recoveryData.email || '').trim();

        if (this.recoverMode === 'password' && !identifier) {
            this.recoveryError = '아이디를 입력해주세요.';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            this.recoveryError = '가입할 때 사용한 이메일을 정확히 입력해주세요.';
        }

        if (!this.recoveryError) {
            this.recoverySent = true;
        }

        await this.service.render();
    }

    public async showLegal(type: string) {
        const documents: any = {
            privacy: {
                title: '개인정보처리방침',
                message: '계정 및 프로젝트 데이터는 서비스 제공에 필요한 범위에서만 처리하며, 품질 개선에는 사용자가 별도로 동의한 데이터만 사용합니다.'
            },
            terms: {
                title: '이용약관',
                message: '업로드한 논문의 이용 권한과 생성 결과의 공개 범위를 사용자가 직접 확인하고 관리하는 것을 원칙으로 합니다.'
            },
            copyright: {
                title: '저작권 안내',
                message: '대본은 논문 저자의 허가 전에도 생성할 수 있으나 권리 확인 책임과 생성물 이용에 따른 법적 책임은 사용자에게 있으며, 서비스는 관련 분쟁에 책임지지 않습니다. 영상 제작은 저자의 영상화 허가를 확인할 수 있는 사진 또는 한글문서(HWP·HWPX)를 제출하고 관리자의 승인을 받은 뒤 가능합니다. 승인 방식은 향후 AI 기반 검토로 대체될 수 있습니다.'
            }
        };
        const document = documents[type];

        await this.service.modal.show({
            title: document.title,
            message: document.message,
            cancel: false,
            action: '확인',
            actionBtn: 'success',
            status: 'success'
        });
    }
}

export default PageAccessComponent;